import type { HumanSignoffStatus } from "@/components/case-checking/problemStatementUi";

const CONFIRMED_CLASS =
  "shrink-0 rounded-md px-2 py-0.5 text-[10px] font-medium text-emerald-800 dark:text-emerald-200 ring-1 ring-inset ring-emerald-500/30 bg-emerald-100 dark:bg-emerald-500/10";

export function SummaryReviewBadge({ status }: { status: HumanSignoffStatus }) {
  if (status === "overridden") {
    return (
      <span
        className="shrink-0 rounded-md px-2 py-0.5 text-[10px] font-medium text-indigo-800 dark:text-indigo-200 ring-1 ring-inset ring-indigo-500/30 bg-indigo-100 dark:bg-indigo-500/10"
        data-testid="summary-review-overridden"
      >
        Overridden
      </span>
    );
  }

  if (status === "pending") {
    return (
      <span
        className="shrink-0 rounded-md px-2 py-0.5 text-[10px] font-medium text-slate-600 dark:text-slate-400 ring-1 ring-inset ring-slate-500/30 bg-slate-100 dark:bg-slate-500/10"
        data-testid="summary-review-pending"
      >
        Pending review
      </span>
    );
  }

  return (
    <span className={CONFIRMED_CLASS} data-testid="summary-review-confirmed">
      Review confirmed
    </span>
  );
}
